import React, { useEffect } from "react";
import {
  subscriptions,
  useUserStore,
  useSubscriptionStore,
} from "../../../state";
import {
  ExpensesIcon,
  InventoryIcon,
  InvoiceIcon,
  ReportIcon,
} from "../../../assets/icons";
import { useReportStore } from "../../../state/useReportStore";
import { useTranslation } from "react-i18next";
import { useCompanyStore } from "../../../state/useCompanyStore";

const SubscriptionUsage = ({
  subscriptionState,
}: {
  subscriptionState: subscriptions | null;
}) => {
  const { t } = useTranslation("subscription");
  const userStore = useCompanyStore();
  const isRetail = userStore.isRetailBusiness();
  const { subscriptionData, fetchActiveSubscription } = useSubscriptionStore();

  useEffect(() => {
    fetchActiveSubscription();

    const interval = setInterval(() => {
      fetchActiveSubscription();
    }, 60000);

    return () => clearInterval(interval);
  }, [fetchActiveSubscription]);

  return (
    <div className="w-full lg:w-[72.4%]">
      <div className="md:border md:border-1 border-[#DFDFDF] rounded-[7px] flex gap-[30px] w-full  flex-col justify-between  md:pb-6 lg:pb-[35px] mt-[12px]">
      <p className="text-lg font-semibold  md:border-b  px-[2px] lg:px-[30px] mb-[-20px] md:py-3">{t("subscription.activeUsage")}</p>
        <div className="flex flex-col gap-[12px] lg:px-[30px] px-[12px] py-6 md:py-0 md:pt-0 md:border-none border border-[#DFDFDF] rounded-md md:rounded-none">
          <div className="flex justify-between">
            <span className="flex items-center gap-[10px]">
              <ExpensesIcon />
              Expenses
            </span>
            <span className="">
              {subscriptionData?.usage?.expenses
                ? subscriptionData?.usage?.expenses
                : 0}
              {" "} out of {" "}
              {subscriptionData?.limits?.expenses
                ? subscriptionData?.limits?.expenses
                : 0}
            </span>
          </div>

          <div className="flex justify-between">
            <span className="flex items-center gap-[10px]">
              <InvoiceIcon />
              Invoices
            </span>
            <span>
              {subscriptionData?.usage?.invoices
                ? subscriptionData?.usage?.invoices
                : 0}
               {" "} out of {" "}
              {subscriptionData?.limits?.invoices
                ? subscriptionData?.limits?.invoices
                : 0}
            </span>
          </div>

          <div className="flex justify-between">
            <span className="flex items-center gap-[10px]">
              <ReportIcon />
              Report
            </span>
            <span>
              {subscriptionData?.usage?.reports
                ? subscriptionData?.usage?.reports
                : 0}
               {" "} out of {" "}
              {subscriptionData?.limits?.reports
                ? subscriptionData?.limits?.reports
                : 0}
            </span>
          </div>

          <div className="flex justify-between ">
            <span className="flex items-center gap-[10px]">
              <InventoryIcon />
              {isRetail ? "Inventories" : "Services"}
            </span>
            <span>
              {isRetail
                ? subscriptionData?.usage?.inventories
                : subscriptionData?.usage?.services}{" "}
              {" "} out of {" "}
              {isRetail
                ? subscriptionData?.limits?.inventories
                : subscriptionData?.limits?.services}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionUsage;
